import React, { Component } from 'react'
import Header from '../Header'
import { Link } from 'react-router-dom'
import './Summer.css'

class Summer extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodySummer">
                    <img src={require("../../img/summer/piste.jpg")} alt="piste" className="piste"></img>
                    <Link to="/Is">
                        <img src={require("../../img/summer/Ie.jpg")} alt="Ie" className="Ie affiche"></img>
                    </Link>
                    <Link to="/IIs">
                        <img src={require("../../img/summer/IIe.jpg")} alt="Ie" className="IIe affiche"></img>
                    </Link>
                    <Link to="/IIIs">
                        <img src={require("../../img/summer/IIIe.jpg")} alt="IIIe" className="IIIe affiche"></img>
                    </Link>
                    <Link to="/IVs">
                        <img src={require("../../img/summer/IVe.jpg")} alt="IVe" className="IVe affiche"></img>
                    </Link>
                    <Link to="/Vs">
                        <img src={require("../../img/summer/Ve.jpg")} alt="Ve" className="Ve affiche"></img>
                    </Link>
                    <Link to="/VIs">
                        <img src={require("../../img/summer/VIe.png")} alt="VIe" className="VIe affiche"></img>
                    </Link>
                    <Link to="/VIIs">
                        <img src={require("../../img/summer/VIIe.jpg")} alt="VIIe" className="VIIe affiche"></img>
                    </Link>
                    <Link to="/VIIIs">
                        <img src={require("../../img/summer/VIIIe.png")} alt="VIIIe" className="VIIIe affiche"></img>
                    </Link>
                    <Link to="/IXs">
                        <img src={require("../../img/summer/IXe.jpg")} alt="IXe" className="IXe affiche"></img>
                    </Link>
                    <Link to="/Xs">
                        <img src={require("../../img/summer/Xe.png")} alt="Xe" className="Xe affiche"></img>
                    </Link>
                    <Link to="/XIs">
                        <img src={require("../../img/summer/XIe.png")} alt="XIe" className="XIe affiche"></img>
                    </Link>
                    <Link to="/XIIs">
                        <img src={require("../../img/summer/XIIe.jpg")} alt="XIIe" className="XIIe affiche"></img>
                    </Link>
                    <Link to="/XIIIs">
                        <img src={require("../../img/summer/XIIIe.png")} alt="XIIIe" className="XIIIe affiche"></img>
                    </Link>
                    <Link to="/XIVs">
                        <img src={require("../../img/summer/XIVe.png")} alt="XIVe" className="XIVe affiche"></img>
                    </Link>
                    <Link to="/XVs">
                        <img src={require("../../img/summer/XVe.png")} alt="XVe" className="XVe affiche"></img>
                    </Link>
                    <Link to="/XVIs">
                        <img src={require("../../img/summer/XVIe.png")} alt="XVIe" className="XVIe affiche"></img>
                    </Link>
                    <Link to="/XVIIs">
                        <img src={require("../../img/summer/XVIIe.gif")} alt="XVIIe" className="XVIIe affiche"></img>
                    </Link>
                    <Link to="/XVIIIs">
                        <img src={require("../../img/summer/XVIIIe.png")} alt="XVIIIe" className="XVIIIe affiche"></img>
                    </Link>
                    <Link to="/XIXs">
                        <img src={require("../../img/summer/XIXe.png")} alt="XIXe" className="XIXe affiche"></img>
                    </Link>
                    <Link to="/XXs">
                        <img src={require("../../img/summer/XXe.png")} alt="XXe" className="XXe affiche"></img>
                    </Link>
                    <Link to="/XXIs">
                        <img src={require("../../img/summer/XXIe.png")} alt="XXIe" className="XXIe affiche"></img>
                    </Link>
                    <Link to="/XXIIs">
                        <img src={require("../../img/summer/XXIIe.png")} alt="XXIIe" className="XXIIe affiche"></img>
                    </Link>
                    <Link to="/XXIIIs">
                        <img src={require("../../img/summer/XXIIIe.png")} alt="XXIIIe" className="XXIIIe affiche"></img>
                    </Link>
                    <Link to="/XXIVs">
                        <img src={require("../../img/summer/XXIVe.png")} alt="XXIVe" className="XXIVe affiche"></img>
                    </Link>
                    <Link to="/XXVs">
                        <img src={require("../../img/summer/XXVe.png")} alt="XXVe" className="XXVe affiche"></img>
                    </Link>
                    <Link to="/XXVIs">
                        <img src={require("../../img/summer/XXVIe.png")} alt="XXVIe" className="XXVIe affiche"></img>
                    </Link>
                    <Link to="/XXVIIs">
                        <img src={require("../../img/summer/XXVIIe.png")} alt="XXVIIe" className="XXVIIe affiche"></img>
                    </Link>
                    <Link to="/XXVIIIs">
                        <img src={require("../../img/summer/XXVIIIe.png")} alt="XXVIIIe" className="XXVIIIe affiche"></img>
                    </Link>
                    <Link to="/XXIXs">
                        <img src={require("../../img/summer/XXIXe.png")} alt="XXIXe" className="XXIXe affiche"></img>
                    </Link>
                    <Link to="/XXXs">
                        <img src={require("../../img/summer/XXXe.png")} alt="XXXe" className="XXXe affiche"></img>
                    </Link>
                    <Link to="/XXXIs">
                        <img src={require("../../img/summer/XXXIe.png")} alt="XXXIe" className="XXXIe affiche"></img>
                    </Link>
                    <Link to="/XXXIIs">
                        <img src={require("../../img/summer/XXXIIe.png")} alt="XXXIIe" className="XXXIIe affiche"></img>
                    </Link>
                    <Link to="/XXXIIIs">
                        <img src={require("../../img/summer/XXXIIIe.png")} alt="XXXIIIe" className="XXXIIIe affiche"></img>
                    </Link>
                    <Link to="/XXXIVs">
                        <img src={require("../../img/summer/XXXIVe.png")} alt="XXXIVe" className="XXXIVe affiche"></img>
                    </Link>
                </div>
            </div>
        )
    }
}

export default Summer